import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import axios from 'axios'

const apiBaseUrl = process.env.VUE_APP_API_BASE_URL || ''
axios.defaults.baseURL = apiBaseUrl
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.withCredentials = true

const app = createApp(App)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.use(store)
app.use(router)
app.use(ElementPlus)

app.mount('#app')
